import React, { useState } from 'react'
import Tooltip from '@mui/material/Tooltip'
import { withStyles } from '@mui/styles'

import lang from 'lang'
import BuhlBankLogo from '@assets/images/banking/buhlBank.svg?url'
import SVGIcon from '@/modules/base/components/svg-icon/svg-icon'
import TextField from '@mui/material/TextField'
import IconHide from '@assets/images/icons/invisible.svg'
import IconShow from '@assets/images/icons/visible.svg'

const BankingPasswordInput = (props) => {
  const { classes, ...otherProps } = props
  const [showPassword, setShowPassword] = useState(false)
  return (
    <div className={classes.container}>
      <TextField
        variant="outlined"
        name={otherProps.name}
        type={showPassword ? 'text' : 'password' }
        label={otherProps.label}
        onChange={otherProps.onChange}
        defaultValue={otherProps.value}
        className={classes.textField}

      />
      <Tooltip className={classes.togglePassword} title={showPassword ? lang.generics.hideText : lang.generics.show}>
        <SVGIcon className={classes.searchIcon} svg={showPassword ? IconShow : IconHide} height='20px' width='20px' onClick={() => setShowPassword(!showPassword)} />
      </Tooltip>
      <Tooltip
        title={lang.bankingBuhlBankInputTooltip}
        classes={{ tooltip: classes.tooltip }}>
        <div className={classes.logo}>
          <SVGIcon svg={BuhlBankLogo} width='80px' height='20px' />
        </div>
      </Tooltip>
    </div>
  )
}

const styles = theme => ({
  container: {
    position: 'relative',
    marginBottom: '24px',
  },
  togglePassword: {
    position: 'absolute',
    right: 97,
    top: 14,
  },
  logo: {
    position: 'absolute',
    right: 16,
    top: 14,
  },
  tooltip: {
    maxWidth: 200,
    marginRight: 50,
  },
  textField: {
    width: '100%',
  },
})

export default withStyles(styles)(BankingPasswordInput)
